
import React from "react";

interface CalculatedValuesProps {
  valorGeracaoEstimada: number;
  payback: string;
  valorKwhMes: string;
}

const CalculatedValues: React.FC<CalculatedValuesProps> = ({ 
  valorGeracaoEstimada, 
  payback, 
  valorKwhMes 
}) => {
  return (
    <div className="bg-muted p-4 rounded-md space-y-2 mt-6">
      <h3 className="font-semibold text-lg text-energy-green-dark">Valores Calculados</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <p className="text-sm text-muted-foreground">Valor Estimado de Geração (R$/mês)</p>
          <p className="font-medium text-lg">
            R$ {valorGeracaoEstimada.toFixed(2)}
          </p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Payback (anos)</p>
          <p className="font-medium text-lg">
            {payback} anos
          </p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Valor do kWh em 25 anos (R$)</p>
          <p className="font-medium text-lg">
            R$ {valorKwhMes}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CalculatedValues;
